// extracted by mini-css-extract-plugin
export var actionText = "_re-4";
export var container = "_re-0";
export var leftSection = "_re-1";
export var rightSection = "_re-2";
export var settingsButton = "_re-6";
export var settingsIcon = "_re-7";
export var shortcut = "_re-5";
export var shortcutGroup = "_re-3";